import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import { Link } from 'react-router-dom';


export class AddNew_ProductDetails extends Component {
    static displayName = AddNew_ProductDetails.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            loading: false,
            alertMessage: "",
            productDetails: "",
            barcodes:[],
            selectedStocktake: "",
            selectedProductId: props.location.state.selectedProductId,
            selectedProductCode: "",
            selectedLocationId: props.location.state.selectedLocationId,
            selectedLocationBarcode: props.location.state.selectedLocationBarcode,
            previouspage: props.location.state.previouspage
    
        }
    }

    componentDidMount() {

        if (!MyGlobal.selected_stocktake) {
            this.clearAll("Please select a Stocktake");
            return;
        }

        var selectedStocktakeParsedData = JSON.parse(MyGlobal.selected_stocktake);
        if (selectedStocktakeParsedData) {
            this.state.selectedStocktake = selectedStocktakeParsedData;
        }

        if (!this.state.selectedStocktake.stocktakeId || this.state.selectedStocktake.stocktakeId === "") {
            this.clearAll("Please select a Stocktake");
            return;
        }

        this.loadProductDetails();

    }
 

    async loadProductDetails() {
        this.state.loading = true;

        fetch(`api/Stocktake/GetColosysProductDetails?stocktakeId=${this.state.selectedStocktake.stocktakeId}&productId=${this.state.selectedProductId}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ products: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                  

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            if (data.isError === false && data.responseDescription === "Product found") {
                                this.setState({ productDetails: data.product_Details, alertMessage: "" });
                                if (data.product_Details && data.product_Details.barcodes && data.product_Details.barcodes.length > 0) {
                                    this.setState({ barcodes: data.product_Details.barcodes });
                                }
                            } else {
                                this.setState({
                                    productDetails: "", alertMessage: "No product details found" });
                            }
                        }
                        else {
                            this.setState({ alertMessage:  apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Product details!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ products: [], alertMessage: error });
            });
    }

   


    render() {
  
       
        let loadingHtml = this.state.loading
            ? <p><em>Loading product details...</em></p>
            : "";

        let barcodesHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderBarcodes();

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <div>
                <Container>
                    <Row>
                        <Col xs={9}><h5>Add Extra - Product Details</h5></Col>
                        <Col xs={3}>
                            <Link className="btn btn-success col-12 mb-2" to={{ pathname: "AddNew_ProductCount", state: this.state}}>Back</Link>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}> {loadingHtml}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Product :</label>
                        </Col>
                        <Col xs={9}>
                            <label> {this.state.productDetails ? this.state.productDetails.productCode.trim() : ""} </label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Description :</label>
                        </Col>
                        <Col xs={9}>
                            <textarea className="form-control" readOnly={true} value={this.state.productDetails ? this.state.productDetails.productDescription : ""} >  </textarea>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>
                            <label> Desc2 :</label>
                        </Col>
                        <Col xs={9}>
                            <textarea className="form-control" readOnly={true} value= {this.state.productDetails ? this.state.productDetails.productDescription2 : ""}>  </textarea>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={12}>
                            {barcodesHtml}
                        </Col>
                       
                    </Row>
                    
                </Container>
            </div>

        );
    }

    renderBarcodes() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>Barcode</label>
                            </th>
                            <th className="col-sm-4">
                                <label>Pack Size</label>
                            </th>
                            <th className="col-sm-4">
                                <label>Pack Type</label>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.barcodes
                            .map(row =>
                                <tr key={row.barcode}>
                                    <td>{row.barcode}</td>
                                    <td>{row.packSize}</td>
                                    <td>{row.packType}</td>
 
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        );
    }
}